// Function that builds News Sliders
const buildHomepageheaderSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`.homepage-header-swiper[data-id="${sliderIdentifier}"]`, {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        a11y: true,
        loop: false,
        grabCursor: true,
        watchSlidesProgress: true,
        watchOverflow: true,

        preloadImages: false,
        lazy: true,

        navigation: {
            nextEl: `.button-next-${sliderIdentifier}`,
            prevEl: `.button-prev-${sliderIdentifier}`,
        },

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });
}

// Get all of the news sliders on the page
const allHomepageheaderSliders = document.querySelectorAll('.homepage-header-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
allHomepageheaderSliders.forEach(slider => buildHomepageheaderSlider(slider));




// Function that builds News Sliders
const buildNewsSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`.news-swiper[data-id="${sliderIdentifier}"]`, {
        slidesPerView: 1,
        spaceBetween: 17,
        centeredSlides: true,
        a11y: true,
        loop: true,
        grabCursor: true,
        watchSlidesProgress: true,

        preloadImages: false,
        lazy: true,

        navigation: {
            nextEl: `.button-next-${sliderIdentifier}`,
            prevEl: `.button-prev-${sliderIdentifier}`,
        },

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },

        breakpoints: {
            600: {
                slidesPerView: 2,
                centeredSlides: false,
              },
            1024: {
              slidesPerView: 3,
              centeredSlides: false,
            },
            1420: {
              slidesPerView: 'auto',
              centeredSlides: false,
            },
        },
    });
}

// Get all of the news sliders on the page
const allNewsSliders = document.querySelectorAll('.news-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
allNewsSliders.forEach(slider => buildNewsSlider(slider));


// Function that builds Types Sliders
const buildTypesSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`.children-types-swiper[data-id="${sliderIdentifier}"]`, {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 17,
        a11y: true,
        loop: false,
        grabCursor: true,
        watchSlidesProgress: true,

        preloadImages: false,
        lazy: true,

        navigation: {
            nextEl: `.button-next-${sliderIdentifier}`,
            prevEl: `.button-prev-${sliderIdentifier}`,
        },

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });
}

// Get all of the types sliders on the page
const allTypesSliders = document.querySelectorAll('.children-types-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
allTypesSliders.forEach(slider => buildTypesSlider(slider));


// Function that builds Evaluation image Sliders
const buildEvalSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    const externalSlideLinks = document.querySelectorAll('.img-example-link');
    let evalSwiper = new Swiper(`.eval-swiper[data-id="${sliderIdentifier}"]`, {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 5,
        a11y: true,
        loop: false,
        grabCursor: true,
        watchSlidesProgress: true,

        preloadImages: false,
        lazy: true,

        navigation: {
            nextEl: `.button-next-${sliderIdentifier}`,
            prevEl: `.button-prev-${sliderIdentifier}`,
        },

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },

        breakpoints: {
            600: {
                slidesPerView: 2,
              },
            1024: {
              slidesPerView: 3,
            },
        },
    });

    const goToSlide = (e) => {
        for (var i = 0; i < evalSwiper.slides.length; i++) {
            evalSwiper.slides[i].classList.remove('highlighted');
        }
        
        const slideTargetIndex = e.currentTarget.getAttribute('data-slide');
        evalSwiper.slideTo(slideTargetIndex);
        evalSwiper.slides[slideTargetIndex].classList.add('highlighted');
        let evalSwiperElement = document.querySelector('.eval-swiper');
        evalSwiperElement.scrollIntoView(true);

        setTimeout(function() {
            evalSwiper.slides[slideTargetIndex].classList.remove('highlighted');
        }, 5000);
    }

    for (var i = 0; i < externalSlideLinks.length; i++) {
        externalSlideLinks[i].addEventListener('click', goToSlide, false);
    }

    return evalSwiper;
}

// Get all of the evaluation image sliders on the page
const allEvalSliders = document.querySelectorAll('.eval-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
allEvalSliders.forEach(slider => buildEvalSlider(slider));




// Function that builds Evaluation image Sliders with Umbraco Markup
const buildUmbracoEvalSlider = sliderElm => {
    const sliderIdentifier = sliderElm;
    const externalSlideLinks = document.querySelectorAll('.umbraco-forms-field-wrapper .file__upload');
    let evalSwiper = new Swiper(`#slider`, {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 5,
        a11y: true,
        loop: false,
        grabCursor: true,
        watchSlidesProgress: true,
        slideClass: 'evaluation__slider__item',

        preloadImages: false,
        lazy: true,

        navigation: {
            nextEl: `#eval-slider-next`,
            prevEl: `#eval-slider-prev`,
        },

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },

        breakpoints: {
            600: {
                slidesPerView: 2,
              },
            1024: {
              slidesPerView: 3,
            },
        },
    });



    const goToSlide = (e) => {
        e.preventDefault();
        for (var i = 0; i < evalSwiper.slides.length; i++) {
            evalSwiper.slides[i].classList.remove('highlighted');
        }
        
        const slideTargetIndex = e.currentTarget.getAttribute('data-slide');
        evalSwiper.slideTo(slideTargetIndex);
        evalSwiper.slides[slideTargetIndex].classList.add('highlighted');
        let evalSwiperElement = document.querySelector('.imageslider');
        evalSwiperElement.scrollIntoView(true);

        setTimeout(function() {
            evalSwiper.slides[slideTargetIndex].classList.remove('highlighted');
        }, 5000);
    }

    for (let i = 0; i < externalSlideLinks.length; i++) {
        externalSlideLinks[i].setAttribute('data-slide' , i);
        externalSlideLinks[i].querySelector('span').textContent = 'View Example';
        externalSlideLinks[i].addEventListener('click', goToSlide, false);
    }

    return evalSwiper;
}

// Get all of the evaluation image sliders on the page
const allUmbracoEvalSliders = document.querySelectorAll('#slider');

// Loop over all of the fetched sliders and apply Swiper on each one.
allUmbracoEvalSliders.forEach(slider => buildUmbracoEvalSlider(slider));



// Function that builds Used Images Sliders
const buildUsedSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    const externalSlideThumbs = document.querySelectorAll('.thumb-wrapper .thumb');
    let mainSwiper = new Swiper(`.used-images-swiper[data-id="${sliderIdentifier}"]`, {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 0,
        a11y: true,
        loop: false,
        grabCursor: true,

        preloadImages: false,
        lazy: true,

        navigation: {
            nextEl: `.button-next-${sliderIdentifier}`,
            prevEl: `.button-prev-${sliderIdentifier}`,
        },

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });

    mainSwiper.on('transitionEnd', function() {
        for (var i = 0; i < externalSlideThumbs.length; i++) {
            externalSlideThumbs[i].classList.remove('active');
            const thumbIndex = externalSlideThumbs[i].getAttribute('data-slide');
            if(thumbIndex == mainSwiper.realIndex){
                externalSlideThumbs[i].classList.add('active');
            }
        }
    });

    const goToSlide = (e) => {
        for (var i = 0; i < mainSwiper.slides.length; i++) {
            mainSwiper.slides[i].classList.remove('highlighted');
        }
        
        const slideTargetIndex = e.currentTarget.getAttribute('data-slide');
        mainSwiper.slideTo(slideTargetIndex);
        mainSwiper.slides[slideTargetIndex].classList.add('highlighted');
        let mainSwiperElement = document.querySelector('.used-images-swiper');
        mainSwiperElement.scrollIntoView(true);

        setTimeout(function() {
            mainSwiper.slides[slideTargetIndex].classList.remove('highlighted');
        }, 5000);
    }

    for (var i = 0; i < externalSlideThumbs.length; i++) {
        externalSlideThumbs[i].addEventListener('click', goToSlide, false);
    }

    return mainSwiper;
}

// Get all of the used images sliders on the page
const allUsedSliders = document.querySelectorAll('.used-images-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
allUsedSliders.forEach(slider => buildUsedSlider(slider));